module.exports = __webpack_public_path__ + "img/logo-full.2ab71fb0.png";